import { getUpsCollaboratorsBuildingLocationsLastError, loadUpsCollaboratorsBuildingLocationsInProgress, type UPSCollaborator, } from "places-ups-location-operations";
import { getCollaboratorsInMeetingsStatus, getCollaboratorsInOfficeStatus, getCollaboratorsOutOfficeStatus, getLastServicePeopleInMeetingsSuccessfullyCompleted, getLastServicePeopleInOfficeSuccessfullyCompleted, } from "../store";

import type { CollaboratorSource } from "hybridspace-common/lib/serviceTypes";
import type { TraceErrorObject } from "owa-analytics-types";

export function getUpsCollaboratorsInBuildingLoading(category: CollaboratorSource): boolean {
    return loadUpsCollaboratorsBuildingLocationsInProgress(category as string);
}

export function getUpsCollaboratorsInBuildingError(category: CollaboratorSource): TraceErrorObject | undefined {
    return getUpsCollaboratorsBuildingLocationsLastError(category as string);
}

export function getUpsCollaboratorsFromBuildingId(category: CollaboratorSource): UPSCollaborator[] | null {
    return category === "collaborator"
        ? getCollaboratorsInOfficeStatus()
        : getCollaboratorsInMeetingsStatus();
}

export function getOutOfOfficeCollaboratorsList(): string[] | null {
    return getCollaboratorsOutOfficeStatus();
}

export function getUpsLastServiceSuccessfullyCompleted(category: CollaboratorSource): boolean {
    return category === "collaborator"
        ? getLastServicePeopleInOfficeSuccessfullyCompleted()
        : getLastServicePeopleInMeetingsSuccessfullyCompleted();
}

export function isUpsOperationForCategoryInProgress(category: CollaboratorSource): boolean {
    return ((getUpsCollaboratorsInBuildingLoading(category) ||
        getUpsCollaboratorsFromBuildingId(category) == null) && // if the operation is in progress or has not started yet(=== null)
        !getUpsLastServiceSuccessfullyCompleted(category));
}
